type IsChildOrganizationViewParams = {
  isSelectedCompanyParentOrganization: boolean;
  selectedCompanyId?: string;
  technologyCompanyId?: string;
};

export const isChildOrganizationView = (params: IsChildOrganizationViewParams): boolean => {
  const { isSelectedCompanyParentOrganization, selectedCompanyId, technologyCompanyId } = params;

  return Boolean(
    isSelectedCompanyParentOrganization &&
      selectedCompanyId &&
      technologyCompanyId &&
      technologyCompanyId !== selectedCompanyId,
  );
};
